import { timeline } from "../../data/building";
import Container from "../ui/Container";
import SectionHeader from "../ui/SectionHeader";

function TimelineSection() {
  return (
    <section className="border-t border-border/70 py-16 sm:py-20">
      <Container className="grid gap-10 lg:grid-cols-[0.72fr_1fr]">
        <SectionHeader title="Journey" subtitle="A focused path from one useful product to a broader studio ecosystem." />
        <ol className="space-y-6">
          {timeline.map((item, index) => (
            <li key={item.title} className="grid grid-cols-[32px_1fr] gap-4">
              <div className="relative flex justify-center">
                <span className="mt-1 flex h-6 w-6 items-center justify-center rounded-full border border-border bg-background text-xs font-medium text-muted">
                  {index + 1}
                </span>
                {index < timeline.length - 1 ? (
                  <span className="absolute bottom-[-24px] top-8 w-px bg-border/80" />
                ) : null}
              </div>
              <div className="pb-1">
                <h3 className="text-sm font-semibold text-primary">{item.title}</h3>
                <p className="mt-1 text-sm leading-6 text-secondary">{item.detail}</p>
              </div>
            </li>
          ))}
        </ol>
      </Container>
    </section>
  );
}

export default TimelineSection;
